/**
 * Phase 2 — Warranty vertical CategoryConfig.
 *
 * Single source of truth for everything warranty-specific. See
 * `/features/insurance/config.js` for full Phase 2 rationale.
 */
export const WARRANTY_CONFIG = {
  id: "warranty",
  label: "Vehicle Warranties",
  singularProviderLabel: "provider",
  pluralProviderLabel: "providers",
  providerType: "provider",

  rateTable: {
    sortOptions: ["featured", "highest-rated"],
    columns: ["provider", "highlight", "editorReview", "rating", "cta"],
    // Iter-190.J — Standardized CTA verb across all surfaces.
    ctaLabel: "Get Quote",
    trustLine: "Free quote · No obligation · Cancel anytime",
    headerLabel: "Top extended warranty providers",
  },

  modalCategory: "warranty",
  weeklyShoppersBenchmark: 1100,

  scoreFields: [
    { key: "score_rates", label: "Plan pricing", weight: "40%" },
    { key: "score_terms", label: "Coverage breadth", weight: "25%" },
    { key: "score_application", label: "Sign-up flow", weight: "20%" },
    { key: "score_support", label: "Claims handling", weight: "15%" },
  ],

  adminDetailsFields: [
    { key: "coverage_type", label: "Coverage type", type: "text", placeholder: "Bumper-to-bumper / Powertrain / Component" },
    { key: "mileage_limit", label: "Mileage limit", type: "number" },
    { key: "deductible_default", label: "Default deductible ($)", type: "number" },
    { key: "transferable", label: "Transferable to new owner", type: "bool" },
    { key: "cancellation_window_days", label: "Cancellation window (days)", type: "number" },
  ],

  adminTableHeader: {
    pluralNoun: "providers",
    numericA: "Rating",
    numericB: "Coverage",
  },

  primaryCta: "Get Quote",

  routes: [
    "/warranty",
    "/warranty/:state",
    "/warranty/:state/:city",
    "/warranty/high-mileage",
    "/warranty/vs-mbi",
  ],

  schemaTypes: ["Product", "Review", "FAQPage", "BreadcrumbList", "Article", "AggregateRating"],

  trustBadges: ["bbb"],

  isCreditVertical: false,
};
